import axios from "axios";
export default {
  getServers() {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/list-all-servers?source=web`,
      [],
      {
        headers: headers,
      }
    );
  },
};
